import Vue from "vue";
import Router from "vue-router";
import AuthGuard from "./auth-guard";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "../views/Login.vue"),
    },
    {
      beforeEnter: AuthGuard,
      path: "/dashboard",
      name: "dasboard",
      component: () =>
        import(/* webpackChunkName: "dashboard" */ "../views/Dashboard.vue"),
    },
    {
      beforeEnter: AuthGuard,
      path: "/triggerEvents",
      name: "triggerEvents",
      component: () =>
        import(
          /* webpackChunkName: "triggerEvents" */ "../views/TriggerEvents.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/events",
      name: "events",
      component: () =>
        import(/* webpackChunkName: "events" */ "../views/Events.vue"),
    },
    {
      beforeEnter: AuthGuard,
      path: "/devices",
      name: "devices",
      component: () =>
        import(/* webpackChunkName: "devices" */ "../views/Devices.vue"),
    },
    {
      beforeEnter: AuthGuard,
      path: "/applications",
      name: "applications",
      component: () =>
        import(
          /* webpackChunkName: "applications" */ "../views/Applications.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/usermanagement",
      name: "usermanagement",
      component: () =>
        import(
          /* webpackChunkName: "usermanagement" */ "../views/UserManagement.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/organizations",
      name: "organizations",
      component: () =>
        import(
          /* webpackChunkName: "organizations" */ "../views/Organizations.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/ownerships",
      name: "ownerships",
      component: () =>
        import(/* webpackChunkName: "ownerships" */ "../views/Ownerships.vue"),
    },
    {
      beforeEnter: AuthGuard,
      path: "/deployments",
      name: "deployments",
      component: () =>
        import(
          /* webpackChunkName: "deployments" */ "../views/Deployments.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/specs",
      name: "specs",
      component: () =>
        import(/* webpackChunkName: "specs" */ "../views/Specs.vue"),
    },
  ],
});
